import React, { useState, useEffect } from 'react';
import {
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Stack,
    Divider,
    Tooltip,
    IconButton,
    Card,
    Skeleton,
    Tabs,
    Tab,
    Box
} from '@mui/material';
import ToggleStyleSwitch from '@CommonRepresentationalDisplay/Switch/ToggleStyleSwitch';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { 
    IoSettingsOutline,
    IoColorPaletteOutline,
    IoLogoWhatsapp,
    IoMailOutline,
    IoNotificationsOutline,
    IoTimeOutline,
    IoEyeOutline,
    IoCheckmarkCircle,
    IoAlertCircle
} from 'react-icons/io5';
import { useReduxActiveUser } from '@Hooks/reduxActiveUserHook/useReduxActiveUser';
import UserPreferenceService from '@Helpers/URLHelpers/UserPreferenceService';
import OrgService from '@Helpers/URLHelpers/OrgService';
import ErrorHandler from '@Root/ErrorHandler';
import { SnackbarManager } from '@CommonFunctionalDisplay/GlobalSnackbar';
import '@Partials/_ComStyles.scss';
import '@Partials/_SimpleStyles.scss';
import './PreferencesPage.scss';

export default function PreferencesPage(props) {
    const [cursor, setCursor] = useState('wait');
    const [theme, setTheme] = useState('system');
    const [pageLoader, setPageLoader] = useState(true);
    const [currentTab, setCurrentTab] = useState(0);
    
    // WhatsApp states
    const [whatsappEnabled, setWhatsappEnabled] = useState(false);
    const [whatsappMorningDashboard, setWhatsappMorningDashboard] = useState(false);
    const [whatsappDashboardFreq, setWhatsappDashboardFreq] = useState('daily');
    const [whatsappUpcomingToday, setWhatsappUpcomingToday] = useState(false);
    const [whatsappOverdueDaily, setWhatsappOverdueDaily] = useState(false);
    const [whatsappUpcomingTomorrow, setWhatsappUpcomingTomorrow] = useState(false);
    const [, setWhatsappAccountUpdates] = useState(false);
    const [whatsappKaiziqUpdates, setWhatsappKaiziqUpdates] = useState(false);
    
    // WhatsApp Assignee
    const [whatsappAssigneeAssigned, setWhatsappAssigneeAssigned] = useState(false);
    const [whatsappAssigneeStatus, setWhatsappAssigneeStatus] = useState(false);
    const [whatsappAssigneeComment, setWhatsappAssigneeComment] = useState(false);
    const [whatsappAssigneeUp2h, setWhatsappAssigneeUp2h] = useState(false);
    const [whatsappAssigneeUp15m, setWhatsappAssigneeUp15m] = useState(false);
    const [whatsappAssigneeOd15m, setWhatsappAssigneeOd15m] = useState(false);
    const [whatsappAssigneeOdWeekly, setWhatsappAssigneeOdWeekly] = useState(false);
    
    // WhatsApp Reporter
    const [whatsappReporterStatus, setWhatsappReporterStatus] = useState(false);
    const [whatsappReporterComment, setWhatsappReporterComment] = useState(false);
    const [whatsappReporterOd15m, setWhatsappReporterOd15m] = useState(false);
    const [whatsappReporterOdWeekly, setWhatsappReporterOdWeekly] = useState(false);
    
    // WhatsApp Watcher
    const [whatsappWatcherStatus, setWhatsappWatcherStatus] = useState(false);
    const [whatsappWatcherComment, setWhatsappWatcherComment] = useState(false);
    const [whatsappWatcherOd15m, setWhatsappWatcherOd15m] = useState(false);
    const [whatsappWatcherOdWeekly, setWhatsappWatcherOdWeekly] = useState(false);

    // Email states
    const [emailEnabled, setEmailEnabled] = useState(false);
    const [, setEmailAccountUpdates] = useState(false);
    const [emailKaiziqUpdates, setEmailKaiziqUpdates] = useState(false);
    
    // Email Assignee
    const [emailAssigneeAssigned, setEmailAssigneeAssigned] = useState(false);
    const [emailAssigneeStatus, setEmailAssigneeStatus] = useState(false);
    const [emailAssigneeNewUpdates, setEmailAssigneeNewUpdates] = useState(false);
    const [emailAssigneeUp2h, setEmailAssigneeUp2h] = useState(false);
    const [emailAssigneeUp15m, setEmailAssigneeUp15m] = useState(false);
    const [emailAssigneeOd15m, setEmailAssigneeOd15m] = useState(false);
    const [emailAssigneeOdWeekly, setEmailAssigneeOdWeekly] = useState(false);
    
    // Email Reporter
    const [emailReporterCreate, setEmailReporterCreate] = useState(false);
    const [emailReporterStatus, setEmailReporterStatus] = useState(false);
    const [emailReporterNewUpdates, setEmailReporterNewUpdates] = useState(false);
    const [emailReporterOd15m, setEmailReporterOd15m] = useState(false);
    const [emailReporterOdWeekly, setEmailReporterOdWeekly] = useState(false);
    
    // Email Watcher
    const [emailWatcherCreate, setEmailWatcherCreate] = useState(false);
    const [emailWatcherStatus, setEmailWatcherStatus] = useState(false);
    const [emailWatcherNewUpdates, setEmailWatcherNewUpdates] = useState(false);
    const [emailWatcherOd15m, setEmailWatcherOd15m] = useState(false);
    const [emailWatcherOdWeekly, setEmailWatcherOdWeekly] = useState(false);

    // Resolve-specific notification settings
    const [resolveWhatsappEnabled, setResolveWhatsappEnabled] = useState(false);
    const [resolveWhatsappMorningDashboard, setResolveWhatsappMorningDashboard] = useState(false);
    const [resolveWhatsappReportQuarterly, setResolveWhatsappReportQuarterly] = useState(false);
    const [resolveWhatsappReportMonthly, setResolveWhatsappReportMonthly] = useState(false);
    const [resolveWhatsappReportWeekly, setResolveWhatsappReportWeekly] = useState(false);
    const [resolveWhatsappReportDaily, setResolveWhatsappReportDaily] = useState(false);
    const [resolveEmailEnabled, setResolveEmailEnabled] = useState(false);
    const [resolveEmailReportQuarterly, setResolveEmailReportQuarterly] = useState(false);
    const [resolveEmailReportMonthly, setResolveEmailReportMonthly] = useState(false);
    const [resolveEmailReportWeekly, setResolveEmailReportWeekly] = useState(false);
    const [resolveEmailReportDaily, setResolveEmailReportDaily] = useState(false);

    // Default Landing Page states
    const [, setDefaultLandingPageType] = useState('landing'); // 'landing' or 'project'
    const [, setDefaultProjectId] = useState(null);
    const [, setDefaultSubPage] = useState('pm'); // 'pm' or 'tickets'
    const [, setProjectList] = useState([]);
    useState(false);

    const { activeUserPreferencesAll, setActiveUserPreferencesAll, activeUserId, activeUserAccessList } = useReduxActiveUser();
    const userPreferenceService = new UserPreferenceService();
    new OrgService();
    const errorHandler = new ErrorHandler();
    const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const APC_ENABLE_INTEGRATIONS_WHATSAPP = JSON.parse(localStorage.getItem('APC_ENABLE_INTEGRATIONS_WHATSAPP'));
    const className = 'preferencesPage';

    // Helpers: safely parse prefs that might be string/object/Map
    const toPlainObject = (val) => {
        if (!val) return {};
        if (typeof val === 'string') {
            try { return JSON.parse(val); } catch { return {}; }
        }
        if (val instanceof Map) return Object.fromEntries(val);
        return val;
    };

    useEffect(() => {
        parseData();
    }, []);

    useEffect(() => {
        loadOrgAndProjectList();
    }, [activeUserAccessList]);

    const parseData = async () => {
        try {
            let prefs = activeUserPreferencesAll || {};

            const userPrefResponse = await userPreferenceService.getUserPreferenceById(activeUserId);
            const serverPrefs = toPlainObject(userPrefResponse?.body);
            if (Object.keys(serverPrefs).length > 0) {
                prefs = {
                    ...prefs,
                    ...serverPrefs,
                };
                setActiveUserPreferencesAll(prefs);
                localStorage.setItem('activeUserPreferences', JSON.stringify(prefs));
            }
            
            // Theme
            setTheme(prefs.theme || 'system');
    
            const landingPref = typeof(activeUserPreferencesAll?.landing) === 'string'
                ? JSON.parse(activeUserPreferencesAll?.landing)
                : activeUserPreferencesAll?.landing;
            const defaultLandingType = !!landingPref ? landingPref?.landingPageType : null;
            setDefaultLandingPageType(defaultLandingType || 'landing');
            setDefaultProjectId(landingPref?.projectId || 0);
            setDefaultSubPage(landingPref?.subPage || 'pm');
            
            // WhatsApp (string | object | Map)
            const whatsapp = toPlainObject(prefs.whatsapp);
            setWhatsappEnabled(whatsapp.enableWhatsappBot ?? true);
            setWhatsappMorningDashboard(whatsapp.enableMorningDashboardMessages ?? true);
            setWhatsappDashboardFreq(whatsapp.enableMorningDashboardMessagesDetails?.messageFrequency || 'daily');
            setWhatsappUpcomingToday(whatsapp.enableMorningUpcomingTodayMessages ?? true);
            setWhatsappOverdueDaily(whatsapp.enableEveningOverdueDailyMessages ?? true);
            setWhatsappUpcomingTomorrow(whatsapp.enableEveningUpcomingTomorrowMessages ?? true);
            setWhatsappAccountUpdates(whatsapp.enableAccountUpdates ?? true);
            setWhatsappKaiziqUpdates(whatsapp.enableKaiziqUpdates ?? true);
            
            const whatsappDetails = whatsapp.enableAccountUpdatesDetails || {};
            setWhatsappAssigneeAssigned(whatsappDetails.assignee?.assignedItems ?? true);
            setWhatsappAssigneeStatus(whatsappDetails.assignee?.statusChange ?? true);
            setWhatsappAssigneeComment(whatsappDetails.assignee?.comments ?? true);
            setWhatsappAssigneeUp2h(whatsappDetails.assignee?.upcoming2Hours ?? true);
            setWhatsappAssigneeUp15m(whatsappDetails.assignee?.upcoming15Minutes ?? true);
            setWhatsappAssigneeOd15m(whatsappDetails.assignee?.overdue15Minutes ?? true);
            setWhatsappAssigneeOdWeekly(whatsappDetails.assignee?.overdueWeekly ?? true);
            setWhatsappReporterStatus(whatsappDetails.reporter?.statusChange ?? true);
            setWhatsappReporterComment(whatsappDetails.reporter?.comments ?? true);
            setWhatsappReporterOd15m(whatsappDetails.reporter?.overdue15Minutes ?? true);
            setWhatsappReporterOdWeekly(whatsappDetails.reporter?.overdueWeekly ?? false);
            setWhatsappWatcherStatus(whatsappDetails.watcher?.statusChange ?? true);
            setWhatsappWatcherComment(whatsappDetails.watcher?.comments ?? true);
            setWhatsappWatcherOd15m(whatsappDetails.watcher?.overdue15Minutes ?? true);
            setWhatsappWatcherOdWeekly(whatsappDetails.watcher?.overdueWeekly ?? false);
            
            // Email (string | object | Map)
            const email = toPlainObject(prefs.email);
            setEmailEnabled(email.enableEmailUpdates ?? true);
            setEmailAccountUpdates(email.enableAccountUpdates ?? true);
            setEmailKaiziqUpdates(email.enableKaiziqUpdates ?? true);

            const whatsappResolve = toPlainObject(whatsapp.resolve);
            const whatsappResolveReports = toPlainObject(whatsappResolve.reports);
            setResolveWhatsappEnabled(whatsappResolve.enableNotifications ?? false);
            setResolveWhatsappMorningDashboard(whatsappResolve.morningDashboardMessage ?? false);
            setResolveWhatsappReportQuarterly(whatsappResolveReports.quarterly ?? false);
            setResolveWhatsappReportMonthly(whatsappResolveReports.monthly ?? false);
            setResolveWhatsappReportWeekly(whatsappResolveReports.weekly ?? false);
            setResolveWhatsappReportDaily(whatsappResolveReports.daily ?? false);

            const emailResolve = toPlainObject(email.resolve);
            const emailResolveReports = toPlainObject(emailResolve.reports);
            setResolveEmailEnabled(emailResolve.enableNotifications ?? false);
            setResolveEmailReportQuarterly(emailResolveReports.quarterly ?? false);
            setResolveEmailReportMonthly(emailResolveReports.monthly ?? false);
            setResolveEmailReportWeekly(emailResolveReports.weekly ?? false);
            setResolveEmailReportDaily(emailResolveReports.daily ?? false);
            
            const emailDetails = email.enableAccountUpdatesDetails || {};
            setEmailAssigneeAssigned(emailDetails.assignee?.assignedItems ?? true);
            setEmailAssigneeStatus(emailDetails.assignee?.statusChange ?? true);
            setEmailAssigneeNewUpdates(emailDetails.assignee?.newUpdates ?? false);
            setEmailAssigneeUp2h(emailDetails.assignee?.upcoming2Hours ?? true);
            setEmailAssigneeUp15m(emailDetails.assignee?.upcoming15Minutes ?? true);
            setEmailAssigneeOd15m(emailDetails.assignee?.overdue15Minutes ?? true);
            setEmailAssigneeOdWeekly(emailDetails.assignee?.overdueWeekly ?? true);
            setEmailReporterCreate(emailDetails.reporter?.create ?? false);
            setEmailReporterStatus(emailDetails.reporter?.statusChange ?? true);
            setEmailReporterNewUpdates(emailDetails.reporter?.newUpdates ?? false);
            setEmailReporterOd15m(emailDetails.reporter?.overdue15Minutes ?? true);
            setEmailReporterOdWeekly(emailDetails.reporter?.overdueWeekly ?? false);
            setEmailWatcherCreate(emailDetails.watcher?.create ?? false);
            setEmailWatcherStatus(emailDetails.watcher?.statusChange ?? true);
            setEmailWatcherNewUpdates(emailDetails.watcher?.newUpdates ?? false);
            setEmailWatcherOd15m(emailDetails.watcher?.overdue15Minutes ?? true);
            setEmailWatcherOdWeekly(emailDetails.watcher?.overdueWeekly ?? false);
            
        } catch (err) {
            errorHandler.handleError(err);
        } finally {
            setCursor('auto');
            setPageLoader(false);
        }
    };

    const updatePreference = async (updates) => {
        setCursor('wait');
        try {
            const prefs = { ...activeUserPreferencesAll, ...updates };
            await userPreferenceService.updateUserPreference(prefs);
            setActiveUserPreferencesAll(prefs);
            localStorage.setItem('activeUserPreferences', JSON.stringify(prefs));
            return true;
        } catch (err) {
            console.error('Error updating preference:', err);
            return false;
        } finally {
            setCursor('auto');
        }
    };

    const loadOrgAndProjectList = async () => {
        try {
            if (activeUserAccessList && activeUserAccessList.projects) {
                // Get projects directly from accessList and enrich with org info
                const projectsWithOrgInfo = activeUserAccessList.projects.map(project => {
                    // Find the parent org for this project
                    const parentOrg = activeUserAccessList.orgs?.find(org => org.id === project.parentId);
                    return {
                        ...project,
                        orgName: parentOrg?.orgName || parentOrg?.name || 'Unknown'
                    };
                });
                setProjectList(projectsWithOrgInfo);
            }
        } catch (err) {
            console.error('Error loading project list:', err);
        }
    };

    const showSuccess = (msg) => SnackbarManager.success(msg);
    const showError = (msg) => SnackbarManager.error(msg);

    const handleTabChange = (event, newValue) => {
        setCurrentTab(newValue);
    };

    const handleThemeChange = async (e) => {
        const newTheme = e.target.value;
        const previousTheme = theme;
        setTheme(newTheme);

        // Apply immediately so the UI switches without waiting for the API
        const targetHtml = document.querySelector('html');
        const resolvedTheme = newTheme === 'system' ? (isDarkMode ? 'dark' : 'light') : newTheme;
        targetHtml.setAttribute('data-theme', resolvedTheme);

        const success = await updatePreference({ theme: newTheme });
        if (success) {
            showSuccess(`Theme updated to ${newTheme.charAt(0).toUpperCase() + newTheme.slice(1)}`);
        } else {
            // Revert on failure
            setTheme(previousTheme);
            const revertResolved = previousTheme === 'system' ? (isDarkMode ? 'dark' : 'light') : previousTheme;
            targetHtml.setAttribute('data-theme', revertResolved);
            showError('Failed to update theme');
        }
    };

    // WhatsApp handlers (use robust parser)
    const getWhatsapp = () => toPlainObject(activeUserPreferencesAll?.whatsapp);
    const getEmail = () => toPlainObject(activeUserPreferencesAll?.email);

    const updateResolveWhatsappPreference = async (resolvePatch = {}) => {
        const whatsapp = { ...getWhatsapp() };
        const currentResolve = toPlainObject(whatsapp.resolve);
        const currentReports = toPlainObject(currentResolve.reports);
        const nextReports = {
            ...currentReports,
            ...toPlainObject(resolvePatch.reports),
        };

        whatsapp.resolve = {
            ...currentResolve,
            ...resolvePatch,
            reports: nextReports,
        };

        return updatePreference({ whatsapp: JSON.stringify(whatsapp) });
    };

    const updateResolveEmailPreference = async (resolvePatch = {}) => {
        const email = { ...getEmail() };
        const currentResolve = toPlainObject(email.resolve);
        const currentReports = toPlainObject(currentResolve.reports);
        const nextReports = {
            ...currentReports,
            ...toPlainObject(resolvePatch.reports),
        };

        email.resolve = {
            ...currentResolve,
            ...resolvePatch,
            reports: nextReports,
        };

        return updatePreference({ email: JSON.stringify(email) });
    };

    const handleResolveWhatsappEnabledToggle = async () => {
        const newVal = !resolveWhatsappEnabled;
        setResolveWhatsappEnabled(newVal);
        const success = await updateResolveWhatsappPreference({ enableNotifications: newVal });
        success ? showSuccess('Resolve WhatsApp notifications updated') : showError('Update failed');
    };

    const handleResolveWhatsappMorningDashboardToggle = async () => {
        const newVal = !resolveWhatsappMorningDashboard;
        setResolveWhatsappMorningDashboard(newVal);
        const success = await updateResolveWhatsappPreference({ morningDashboardMessage: newVal });
        success ? showSuccess('Resolve WhatsApp morning dashboard updated') : showError('Update failed');
    };

    const handleResolveWhatsappReportToggle = async (key, state, setState) => {
        const newVal = !state;
        setState(newVal);
        const success = await updateResolveWhatsappPreference({ reports: { [key]: newVal } });
        success ? showSuccess('Resolve WhatsApp report settings updated') : showError('Update failed');
    };

    const handleResolveEmailEnabledToggle = async () => {
        const newVal = !resolveEmailEnabled;
        setResolveEmailEnabled(newVal);
        const success = await updateResolveEmailPreference({ enableNotifications: newVal });
        success ? showSuccess('Resolve email notifications updated') : showError('Update failed');
    };

    const handleResolveEmailReportToggle = async (key, state, setState) => {
        const newVal = !state;
        setState(newVal);
        const success = await updateResolveEmailPreference({ reports: { [key]: newVal } });
        success ? showSuccess('Resolve email report settings updated') : showError('Update failed');
    };

    const handleWhatsappEnabledToggle = async () => {
        const newVal = !whatsappEnabled;
        setWhatsappEnabled(newVal);
        const whatsapp = { ...getWhatsapp(), enableWhatsappBot: newVal };
        const success = await updatePreference({ whatsapp: JSON.stringify(whatsapp) });
        success ? showSuccess(`WhatsApp Bot ${newVal ? 'enabled' : 'disabled'}`) : showError('Update failed');
    };

    const handleWhatsappAssigneeAssignedToggle = async () => {
        const newVal = !whatsappAssigneeAssigned;
        setWhatsappAssigneeAssigned(newVal);
        const whatsapp = { ...getWhatsapp() };
        whatsapp.enableAccountUpdatesDetails = whatsapp.enableAccountUpdatesDetails || {};
        whatsapp.enableAccountUpdatesDetails.assignee = whatsapp.enableAccountUpdatesDetails.assignee || {};
        whatsapp.enableAccountUpdatesDetails.assignee.assignedItems = newVal;
        const success = await updatePreference({ whatsapp: JSON.stringify(whatsapp) });
        success ? showSuccess('Setting updated') : showError('Update failed');
    };

    const handleWhatsappMorningDashboardSwitch = async () => {
        const newVal = !whatsappMorningDashboard;
        setWhatsappMorningDashboard(newVal);
        const whatsapp = { ...getWhatsapp() };
        whatsapp.enableMorningDashboardMessages = newVal;
        const success = await updatePreference({ whatsapp: JSON.stringify(whatsapp) });
        success ? showSuccess('Morning Dashboard settings updated successfully!') : showError('WhatsApp Bot Update failed, please try again, or contact support');
    };

    const handleWhatsappUpcomingToggle = async () => {
        const newVal = !whatsappUpcomingToday;
        setWhatsappUpcomingToday(newVal);
        const whatsapp = { ...getWhatsapp() };
        whatsapp.enableMorningUpcomingTodayMessages = newVal;
        const success = await updatePreference({ whatsapp: JSON.stringify(whatsapp) });
        success ? showSuccess('Your WhatsApp Upcoming Today Message preference has been updated.') : showError('WhatsApp Upcoming Today Message preference update failed, please try again, or contact support');
    };

    const handleWhatsappOverdueToggle = async () => {
        const newVal = !whatsappOverdueDaily;
        setWhatsappOverdueDaily(newVal);
        const whatsapp = { ...getWhatsapp() };
        whatsapp.enableEveningOverdueDailyMessages = newVal;
        const success = await updatePreference({ whatsapp: JSON.stringify(whatsapp) });
        success ? showSuccess('Your WhatsApp Overdue Message preference has been updated.') : showError('WhatsApp Overdue Message preference update failed, please try again, or contact support');
    };

    const handleWhatsappUpcomingTomorrowToggle = async () => {
        const newVal = !whatsappUpcomingTomorrow;
        setWhatsappUpcomingTomorrow(newVal);
        const whatsapp = { ...getWhatsapp() };
        whatsapp.enableEveningUpcomingTomorrowMessages = newVal;
        const success = await updatePreference({ whatsapp: JSON.stringify(whatsapp) });
        success ? showSuccess('Your WhatsApp Upcoming Tomorrow Message preference has been updated.') : showError('WhatsApp Upcoming Tomorrow Message preference update failed, please try again, or contact support');
    };

    const handleWhatsappAssigneeStatusToggle = async(e) => {
        const newVal = !whatsappAssigneeStatus;
        setWhatsappAssigneeStatus(newVal);
        const whatsapp = { ...getWhatsapp() };
        whatsapp.enableAccountUpdatesDetails = whatsapp.enableAccountUpdatesDetails || {};
        whatsapp.enableAccountUpdatesDetails.assignee = whatsapp.enableAccountUpdatesDetails.assignee || {};
        whatsapp.enableAccountUpdatesDetails.assignee.statusChange = newVal;
        const success = await updatePreference({ whatsapp: JSON.stringify(whatsapp) });
        success ? showSuccess('Status Settings updated') : showError('Update failed');
    };

    const handleWhatsappAssigneeCommentToggle = async(e) => {
        const newVal = !whatsappAssigneeComment;
        setWhatsappAssigneeComment(newVal);
        const whatsapp = { ...getWhatsapp() };
        whatsapp.enableAccountUpdatesDetails = whatsapp.enableAccountUpdatesDetails || {};
        whatsapp.enableAccountUpdatesDetails.assignee = whatsapp.enableAccountUpdatesDetails.assignee || {};
        whatsapp.enableAccountUpdatesDetails.assignee.comments = newVal;
        const success = await updatePreference({ whatsapp: JSON.stringify(whatsapp) });
        success ? showSuccess('Comment Settings updated') : showError('Update failed');
    };

    const handleWhatsappAssigneeUp2hToggle = async(e) => {
        const newVal = !whatsappAssigneeUp2h;
        setWhatsappAssigneeUp2h(newVal);
        const whatsapp = { ...getWhatsapp() };
        whatsapp.enableAccountUpdatesDetails = whatsapp.enableAccountUpdatesDetails || {};
        whatsapp.enableAccountUpdatesDetails.assignee = whatsapp.enableAccountUpdatesDetails.assignee || {};
        whatsapp.enableAccountUpdatesDetails.assignee.upcoming2Hours = newVal;
        const success = await updatePreference({ whatsapp: JSON.stringify(whatsapp) });
        success ? showSuccess('Upcoming Messages Settings updated') : showError('Update failed');
    };

    const handleWhatsappAssigneeUp15mToggle = async(e) => {
        const newVal = !whatsappAssigneeUp15m;
        setWhatsappAssigneeUp15m(newVal);
        const whatsapp = { ...getWhatsapp() };
        whatsapp.enableAccountUpdatesDetails = whatsapp.enableAccountUpdatesDetails || {};
        whatsapp.enableAccountUpdatesDetails.assignee = whatsapp.enableAccountUpdatesDetails.assignee || {};
        whatsapp.enableAccountUpdatesDetails.assignee.upcoming15Minutes = newVal;
        const success = await updatePreference({ whatsapp: JSON.stringify(whatsapp) });
        success ? showSuccess('Upcoming Messages Settings updated') : showError('Update failed');
    };

    const handleWhatsappAssigneeOd15mToggle = async(e) => {
        const newVal = !whatsappAssigneeOd15m;
        setWhatsappAssigneeOd15m(newVal);
        const whatsapp = { ...getWhatsapp() };
        whatsapp.enableAccountUpdatesDetails = whatsapp.enableAccountUpdatesDetails || {};
        whatsapp.enableAccountUpdatesDetails.assignee = whatsapp.enableAccountUpdatesDetails.assignee || {};
        whatsapp.enableAccountUpdatesDetails.assignee.overdue15Minutes = newVal;
        const success = await updatePreference({ whatsapp: JSON.stringify(whatsapp) });
        success ? showSuccess('Overdue Messages Settings updated') : showError('Update failed');
    };

    const handleWhatsappAssigneeOdWeeklyToggle = async(e) => {
        const newVal = !whatsappAssigneeOdWeekly;
        setWhatsappAssigneeOdWeekly(newVal);
        const whatsapp = { ...getWhatsapp() };
        whatsapp.enableAccountUpdatesDetails = whatsapp.enableAccountUpdatesDetails || {};
        whatsapp.enableAccountUpdatesDetails.assignee = whatsapp.enableAccountUpdatesDetails.assignee || {};
        whatsapp.enableAccountUpdatesDetails.assignee.overdueWeekly = newVal;
        const success = await updatePreference({ whatsapp: JSON.stringify(whatsapp) });
        success ? showSuccess('Overdue Messages Settings updated') : showError('Update failed');
    };

    const handleWhatsappReporterStatusToggle = async(e) => {
        const newVal = !whatsappReporterStatus;
        setWhatsappReporterStatus(newVal);
        const whatsapp = { ...getWhatsapp() };
        whatsapp.enableAccountUpdatesDetails = whatsapp.enableAccountUpdatesDetails || {};
        whatsapp.enableAccountUpdatesDetails.reporter = whatsapp.enableAccountUpdatesDetails.reporter || {};
        whatsapp.enableAccountUpdatesDetails.reporter.statusChange = newVal;
        const success = await updatePreference({ whatsapp: JSON.stringify(whatsapp) });
        success ? showSuccess('Status Settings updated') : showError('Update failed');
    };

    const handleWhatsappReporterCommentToggle = async(e) => {
        const newVal = !whatsappReporterComment;
        setWhatsappReporterComment(newVal);
        const whatsapp = { ...getWhatsapp() };
        whatsapp.enableAccountUpdatesDetails = whatsapp.enableAccountUpdatesDetails || {};
        whatsapp.enableAccountUpdatesDetails.reporter = whatsapp.enableAccountUpdatesDetails.reporter || {};
        whatsapp.enableAccountUpdatesDetails.reporter.comments = newVal;
        const success = await updatePreference({ whatsapp: JSON.stringify(whatsapp) });
        success ? showSuccess('Comment Settings updated') : showError('Update failed');
    };

    const handleWhatsappReporterOd15mToggle = async(e) => {
        const newVal = !whatsappReporterOd15m;
        setWhatsappReporterOd15m(newVal);
        const whatsapp = { ...getWhatsapp() };
        whatsapp.enableAccountUpdatesDetails = whatsapp.enableAccountUpdatesDetails || {};
        whatsapp.enableAccountUpdatesDetails.reporter = whatsapp.enableAccountUpdatesDetails.reporter || {};
        whatsapp.enableAccountUpdatesDetails.reporter.overdue15Minutes = newVal;
        const success = await updatePreference({ whatsapp: JSON.stringify(whatsapp) });
        success ? showSuccess('Overdue Messages Settings updated') : showError('Update failed');
    };

    const handleWhatsappReporterOdWeeklyToggle = async(e) => {
        const newVal = !whatsappReporterOdWeekly;
        setWhatsappReporterOdWeekly(newVal);
        const whatsapp = { ...getWhatsapp() };
        whatsapp.enableAccountUpdatesDetails = whatsapp.enableAccountUpdatesDetails || {};
        whatsapp.enableAccountUpdatesDetails.reporter = whatsapp.enableAccountUpdatesDetails.reporter || {};
        whatsapp.enableAccountUpdatesDetails.reporter.overdueWeekly = newVal;
        const success = await updatePreference({ whatsapp: JSON.stringify(whatsapp) });
        success ? showSuccess('Overdue Messages Settings updated') : showError('Update failed');
    };

    const handleWhatsappWatcherStatusToggle = async(e) => {
        const newVal = !whatsappWatcherStatus;
        setWhatsappWatcherStatus(newVal);
        const whatsapp = { ...getWhatsapp() };
        whatsapp.enableAccountUpdatesDetails = whatsapp.enableAccountUpdatesDetails || {};
        whatsapp.enableAccountUpdatesDetails.watcher = whatsapp.enableAccountUpdatesDetails.watcher || {};
        whatsapp.enableAccountUpdatesDetails.watcher.statusChange = newVal;
        const success = await updatePreference({ whatsapp: JSON.stringify(whatsapp) });
        success ? showSuccess('Status Settings updated') : showError('Update failed');
    };

    const handleWhatsappWatcherCommentToggle = async(e) => {
        const newVal = !whatsappWatcherComment;
        setWhatsappWatcherComment(newVal);
        const whatsapp = { ...getWhatsapp() };
        whatsapp.enableAccountUpdatesDetails = whatsapp.enableAccountUpdatesDetails || {};
        whatsapp.enableAccountUpdatesDetails.watcher = whatsapp.enableAccountUpdatesDetails.watcher || {};
        whatsapp.enableAccountUpdatesDetails.watcher.comments = newVal;
        const success = await updatePreference({ whatsapp: JSON.stringify(whatsapp) });
        success ? showSuccess('Comment Settings updated') : showError('Update failed');
    };

    const handleWhatsappWatcherOd15mToggle = async(e) => {
        const newVal = !whatsappWatcherOd15m;
        setWhatsappWatcherOd15m(newVal);
        const whatsapp = { ...getWhatsapp() };
        whatsapp.enableAccountUpdatesDetails = whatsapp.enableAccountUpdatesDetails || {};
        whatsapp.enableAccountUpdatesDetails.watcher = whatsapp.enableAccountUpdatesDetails.watcher || {};
        whatsapp.enableAccountUpdatesDetails.watcher.overdue15Minutes = newVal;
        const success = await updatePreference({ whatsapp: JSON.stringify(whatsapp) });
        success ? showSuccess('Overdue Messages Settings updated') : showError('Update failed');
    };

    const handleWhatsappWatcherOdWeeklyToggle = async(e) => {
        const newVal = !whatsappWatcherOdWeekly;
        setWhatsappWatcherOdWeekly(newVal);
        const whatsapp = { ...getWhatsapp() };
        whatsapp.enableAccountUpdatesDetails = whatsapp.enableAccountUpdatesDetails || {};
        whatsapp.enableAccountUpdatesDetails.watcher = whatsapp.enableAccountUpdatesDetails.watcher || {};
        whatsapp.enableAccountUpdatesDetails.watcher.overdueWeekly = newVal;
        const success = await updatePreference({ whatsapp: JSON.stringify(whatsapp) });
        success ? showSuccess('Overdue Messages Settings updated') : showError('Update failed');
    };

    // Email handlers
    const handleEmailEnabledToggle = async () => {
        const newVal = !emailEnabled;
        setEmailEnabled(newVal);
        const email = { ...getEmail(), enableEmailUpdates: newVal };
        const success = await updatePreference({ email: JSON.stringify(email) });
        success ? showSuccess(`Email notifications ${newVal ? 'enabled' : 'disabled'}`) : showError('Update failed');
    };

    const handleEmailAssigneeAssignedToggle = async(e) => {
        const newVal = !emailAssigneeAssigned;
        setEmailAssigneeAssigned(newVal);
        const email = { ...getEmail() };
        email.enableAccountUpdatesDetails = email.enableAccountUpdatesDetails || {};
        email.enableAccountUpdatesDetails.assignee = email.enableAccountUpdatesDetails.assignee || {};
        email.enableAccountUpdatesDetails.assignee.assignedItems = newVal;
        const success = await updatePreference({ email: JSON.stringify(email) });
        success ? showSuccess('Assigned Items Settings updated') : showError('Update failed');
    };

    const handleEmailAssigneeStatusToggle = async(e) => {
        const newVal = !emailAssigneeStatus;
        setEmailAssigneeStatus(newVal);
        const email = { ...getEmail() };
        email.enableAccountUpdatesDetails = email.enableAccountUpdatesDetails || {};
        email.enableAccountUpdatesDetails.assignee = email.enableAccountUpdatesDetails.assignee || {};
        email.enableAccountUpdatesDetails.assignee.statusChange = newVal;
        const success = await updatePreference({ email: JSON.stringify(email) });
        success ? showSuccess('Status Settings updated') : showError('Update failed');
    };

    const handleEmailAssigneeNewUpdatesToggle = async(e) => {
        const newVal = !emailAssigneeNewUpdates;
        setEmailAssigneeNewUpdates(newVal);
        const email = { ...getEmail() };
        email.enableAccountUpdatesDetails = email.enableAccountUpdatesDetails || {};
        email.enableAccountUpdatesDetails.assignee = email.enableAccountUpdatesDetails.assignee || {};
        email.enableAccountUpdatesDetails.assignee.newUpdates = newVal;
        const success = await updatePreference({ email: JSON.stringify(email) });
        success ? showSuccess('New Updates Settings updated') : showError('Update failed');
    };

    const handleEmailAssigneeUp2hToggle = async(e) => {
        const newVal = !emailAssigneeUp2h;
        setEmailAssigneeUp2h(newVal);
        const email = { ...getEmail() };
        email.enableAccountUpdatesDetails = email.enableAccountUpdatesDetails || {};
        email.enableAccountUpdatesDetails.assignee = email.enableAccountUpdatesDetails.assignee || {};
        email.enableAccountUpdatesDetails.assignee.upcoming2Hours = newVal;
        const success = await updatePreference({ email: JSON.stringify(email) });
        success ? showSuccess('Upcoming Messages Settings updated') : showError('Update failed');
    };

    const handleEmailAssigneeUp15mToggle = async(e) => {
        const newVal = !emailAssigneeUp15m;
        setEmailAssigneeUp15m(newVal);
        const email = { ...getEmail() };
        email.enableAccountUpdatesDetails = email.enableAccountUpdatesDetails || {};
        email.enableAccountUpdatesDetails.assignee = email.enableAccountUpdatesDetails.assignee || {};
        email.enableAccountUpdatesDetails.assignee.upcoming15Minutes = newVal;
        const success = await updatePreference({ email: JSON.stringify(email) });
        success ? showSuccess('Upcoming Messages Settings updated') : showError('Update failed');
    };

    const handleEmailAssigneeOd15mToggle = async(e) => {
        const newVal = !emailAssigneeOd15m;
        setEmailAssigneeOd15m(newVal);
        const email = { ...getEmail() };
        email.enableAccountUpdatesDetails = email.enableAccountUpdatesDetails || {};
        email.enableAccountUpdatesDetails.assignee = email.enableAccountUpdatesDetails.assignee || {};
        email.enableAccountUpdatesDetails.assignee.overdue15Minutes = newVal;
        const success = await updatePreference({ email: JSON.stringify(email) });
        success ? showSuccess('Overdue Messages Settings updated') : showError('Update failed');
    };

    const handleEmailAssigneeOdWeeklyToggle = async(e) => {
        const newVal = !emailAssigneeOdWeekly;
        setEmailAssigneeOdWeekly(newVal);
        const email = { ...getEmail() };
        email.enableAccountUpdatesDetails = email.enableAccountUpdatesDetails || {};
        email.enableAccountUpdatesDetails.assignee = email.enableAccountUpdatesDetails.assignee || {};
        email.enableAccountUpdatesDetails.assignee.overdueWeekly = newVal;
        const success = await updatePreference({ email: JSON.stringify(email) });
        success ? showSuccess('Overdue Messages Settings updated') : showError('Update failed');
    };

    const handleEmailReporterCreateToggle = async(e) => {
        const newVal = !emailReporterCreate;
        setEmailReporterCreate(newVal);
        const email = { ...getEmail() };
        email.enableAccountUpdatesDetails = email.enableAccountUpdatesDetails || {};
        email.enableAccountUpdatesDetails.reporter = email.enableAccountUpdatesDetails.reporter || {};
        email.enableAccountUpdatesDetails.reporter.create = newVal;
        const success = await updatePreference({ email: JSON.stringify(email) });
        success ? showSuccess('Created Items Settings updated') : showError('Update failed');
    };

    const handleEmailReporterStatusToggle = async(e) => {
        const newVal = !emailReporterStatus;
        setEmailReporterStatus(newVal);
        const email = { ...getEmail() };
        email.enableAccountUpdatesDetails = email.enableAccountUpdatesDetails || {};
        email.enableAccountUpdatesDetails.reporter = email.enableAccountUpdatesDetails.reporter || {};
        email.enableAccountUpdatesDetails.reporter.statusChange = newVal;
        const success = await updatePreference({ email: JSON.stringify(email) });
        success ? showSuccess('Status Settings updated') : showError('Update failed');
    };

    const handleEmailReporterNewUpdatesToggle = async(e) => {
        const newVal = !emailReporterNewUpdates;
        setEmailReporterNewUpdates(newVal);
        const email = { ...getEmail() };
        email.enableAccountUpdatesDetails = email.enableAccountUpdatesDetails || {};
        email.enableAccountUpdatesDetails.reporter = email.enableAccountUpdatesDetails.reporter || {};
        email.enableAccountUpdatesDetails.reporter.newUpdates = newVal;
        const success = await updatePreference({ email: JSON.stringify(email) });
        success ? showSuccess('New Updates Settings updated') : showError('Update failed');
    };

    const handleEmailReporterOd15mToggle = async(e) => {
        const newVal = !emailReporterOd15m;
        setEmailReporterOd15m(newVal);
        const email = { ...getEmail() };
        email.enableAccountUpdatesDetails = email.enableAccountUpdatesDetails || {};
        email.enableAccountUpdatesDetails.reporter = email.enableAccountUpdatesDetails.reporter || {};
        email.enableAccountUpdatesDetails.reporter.overdue15Minutes = newVal;
        const success = await updatePreference({ email: JSON.stringify(email) });
        success ? showSuccess('Overdue Items Settings updated') : showError('Update failed');
    };

    const handleEmailReporterOdWeeklyToggle = async(e) => {
        const newVal = !emailReporterOdWeekly;
        setEmailReporterOdWeekly(newVal);
        const email = { ...getEmail() };
        email.enableAccountUpdatesDetails = email.enableAccountUpdatesDetails || {};
        email.enableAccountUpdatesDetails.reporter = email.enableAccountUpdatesDetails.reporter || {};
        email.enableAccountUpdatesDetails.reporter.overdueWeekly = newVal;
        const success = await updatePreference({ email: JSON.stringify(email) });
        success ? showSuccess('Overdue Items Settings updated') : showError('Update failed');
    };

    const handleEmailWatcherCreateToggle = async(e) => {
        const newVal = !emailWatcherCreate;
        setEmailWatcherCreate(newVal);
        const email = { ...getEmail() };
        email.enableAccountUpdatesDetails = email.enableAccountUpdatesDetails || {};
        email.enableAccountUpdatesDetails.watcher = email.enableAccountUpdatesDetails.watcher || {};
        email.enableAccountUpdatesDetails.watcher.create = newVal;
        const success = await updatePreference({ email: JSON.stringify(email) });
        success ? showSuccess('Created Items Settings updated') : showError('Update failed');
    };

    const handleEmailWatcherStatusToggle = async(e) => {
        const newVal = !emailWatcherStatus;
        setEmailWatcherStatus(newVal);
        const email = { ...getEmail() };
        email.enableAccountUpdatesDetails = email.enableAccountUpdatesDetails || {};
        email.enableAccountUpdatesDetails.watcher = email.enableAccountUpdatesDetails.watcher || {};
        email.enableAccountUpdatesDetails.watcher.statusChange = newVal;
        const success = await updatePreference({ email: JSON.stringify(email) });
        success ? showSuccess('Status Settings updated') : showError('Update failed');
    };

    const handleEmailWatcherNewUpdatesToggle = async(e) => {
        const newVal = !emailWatcherNewUpdates;
        setEmailWatcherNewUpdates(newVal);
        const email = { ...getEmail() };
        email.enableAccountUpdatesDetails = email.enableAccountUpdatesDetails || {};
        email.enableAccountUpdatesDetails.watcher = email.enableAccountUpdatesDetails.watcher || {};
        email.enableAccountUpdatesDetails.watcher.newUpdates = newVal;
        const success = await updatePreference({ email: JSON.stringify(email) });
        success ? showSuccess('New Updates Settings updated') : showError('Update failed');
    };

    const handleEmailWatcherOd15minToggle = async(e) => {
        const newVal = !emailWatcherOd15m;
        setEmailWatcherOd15m(newVal);
        const email = { ...getEmail() };
        email.enableAccountUpdatesDetails = email.enableAccountUpdatesDetails || {};
        email.enableAccountUpdatesDetails.watcher = email.enableAccountUpdatesDetails.watcher || {};
        email.enableAccountUpdatesDetails.watcher.overdue15Minutes = newVal;
        const success = await updatePreference({ email: JSON.stringify(email) });
        success ? showSuccess('Overdue Items Settings updated') : showError('Update failed');
    };

    const handleEmailWatcherOdWeeklyToggle = async(e) => {
        const newVal = !emailWatcherOdWeekly;
        setEmailWatcherOdWeekly(newVal);
        const email = { ...getEmail() };
        email.enableAccountUpdatesDetails = email.enableAccountUpdatesDetails || {};
        email.enableAccountUpdatesDetails.watcher = email.enableAccountUpdatesDetails.watcher || {};
        email.enableAccountUpdatesDetails.watcher.overdueWeekly = newVal;
        const success = await updatePreference({ email: JSON.stringify(email) });
        success ? showSuccess('Overdue Items Settings updated') : showError('Update failed');
    };

    const handleEmailKaiziqUpdatesToggle = async () => {
        const newVal = !emailKaiziqUpdates;
        setEmailKaiziqUpdates(newVal);
        const email = { ...getEmail() };
        email.enableKaiziqUpdates = newVal;
        const success = await updatePreference({ email: JSON.stringify(email) });
        success ? showSuccess('Preferences updated') : showError('Update failed');
    };

    const SettingRow = ({ label, checked, onChange, disabled, tooltip }) => (
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ py: 1 }}>
            <Stack direction="row" alignItems="center" gap={1}>
                <Typography 
                    variant="body2" 
                    sx={{ 
                        color: disabled ? 'var(--color-primaryGrey)' : 'var(--color-text)',
                        fontWeight: 500
                    }}
                >
                    {label}
                </Typography>
                {tooltip && (
                    <Tooltip title={tooltip} arrow placement="top">
                        <IconButton size="small" sx={{ p: 0.5, color: 'var(--color-sidePanelIcon)' }}>
                            <InfoOutlinedIcon sx={{ fontSize: 18, color: 'var(--color-sidePanelIcon)' }} />
                        </IconButton>
                    </Tooltip>
                )}
            </Stack>
            <ToggleStyleSwitch checked={checked} onChange={onChange} disabled={disabled} size="small" />
        </Stack>
    );

    const ThemeOption = ({ value, label, icon: Icon, description }) => {
        const isSelected = theme === value;
        return (
            <div 
                className={`${className}__theme-option ${isSelected ? `${className}__theme-option--active` : ''}`}
                onClick={() => !isSelected && handleThemeChange({ target: { value } })}
            >
                <div className={`${className}__theme-option__icon`}>
                    <Icon />
                </div>
                <div className={`${className}__theme-option__content`}>
                    <h4>{label}</h4>
                    <p>{description}</p>
                </div>
                {isSelected && (
                    <div className={`${className}__theme-option__check`}>
                        <IoCheckmarkCircle />
                    </div>
                )}
            </div>
        );
    };

    if (pageLoader) {
        return (
            <div className={className}>
                <div className={className + '__header'}>
                    <Skeleton variant="circular" width={56} height={56} />
                    <div style={{ flex: 1 }}>
                        <Skeleton width="40%" height={32} />
                        <Skeleton width="60%" height={20} sx={{ mt: 1 }} />
                    </div>
                </div>
                <div className={className + '__container'}>
                    {[...Array(3)].map((_, i) => (
                        <Card key={i} sx={{ p: 3, mb: 2 }}>
                            <Skeleton width="30%" height={24} sx={{ mb: 2 }} />
                            <Skeleton width="100%" height={60} />
                        </Card>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div className={className} style={{ cursor }}>
            {/* Header */}
            <div className={`${className}__header`}>
                <div className={`${className}__header__icon`}>
                    <IoSettingsOutline />
                </div>
                <div className={`${className}__header__content`}>
                    <h1 className={`${className}__header__title`}>Preferences</h1>
                    <p className={`${className}__header__subtitle`}>
                        Customize your experience and notification settings
                    </p>
                </div>
            </div>

            <div className={`${className}__container`}>
                {/* Tabs */}
                <Box sx={{ borderBottom: 1, borderColor: 'var(--color-border)', mb: 3 }}>
                    <Tabs 
                        value={currentTab} 
                        onChange={handleTabChange}
                        sx={{
                            '& .MuiTabs-indicator': {
                                backgroundColor: 'var(--color-primaryBlue)',
                                height: 3
                            },
                            '& .MuiTab-root': {
                                color: 'var(--color-text)',
                                textTransform: 'none',
                                fontSize: '0.95rem',
                                fontWeight: 500,
                                '&.Mui-selected': {
                                    color: 'var(--color-primaryBlue)',
                                    fontWeight: 600
                                },
                                '&:hover': {
                                    color: 'var(--color-primaryBlue)',
                                    backgroundColor: 'rgba(0, 75, 147, 0.05)'
                                }
                            }
                        }}
                    >
                        <Tab label="Notifications" />
                        <Tab label="Appearance" />
                    </Tabs>
                </Box>

                {/* Notifications Tab */}
                {currentTab === 0 && (
                    <div>
                        {APC_ENABLE_INTEGRATIONS_WHATSAPP && (
                            <div className={`${className}__section`}>
                                <div className={`${className}__section__header`}>
                                    <IoLogoWhatsapp />
                                    <h2>WhatsApp Notifications</h2>
                                </div>
                                <div className={`${className}__section__content`}>
                                    <p className={`${className}__section__description`}>
                                        Configure Resolve-specific WhatsApp notifications. Existing non-Resolve WhatsApp preferences are kept unchanged.
                                    </p>
                                    <SettingRow
                                        label="Enable WhatsApp notifications"
                                        checked={resolveWhatsappEnabled}
                                        onChange={handleResolveWhatsappEnabledToggle}
                                    />

                                    <Divider sx={{ my: 2 }} />
                                    <Typography variant="caption" color="var(--color-text)" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                                        Resolve WhatsApp Settings
                                    </Typography>

                                    <Stack spacing={0.5} sx={{ mt: 1 }}>
                                        <SettingRow
                                            label="Morning Dashboard Message"
                                            checked={resolveWhatsappMorningDashboard}
                                            onChange={handleResolveWhatsappMorningDashboardToggle}
                                            disabled={!resolveWhatsappEnabled}
                                        />
                                        <SettingRow
                                            label="Quarterly Report"
                                            checked={resolveWhatsappReportQuarterly}
                                            onChange={() => handleResolveWhatsappReportToggle('quarterly', resolveWhatsappReportQuarterly, setResolveWhatsappReportQuarterly)}
                                            disabled={!resolveWhatsappEnabled}
                                        />
                                        <SettingRow
                                            label="Monthly Report"
                                            checked={resolveWhatsappReportMonthly}
                                            onChange={() => handleResolveWhatsappReportToggle('monthly', resolveWhatsappReportMonthly, setResolveWhatsappReportMonthly)}
                                            disabled={!resolveWhatsappEnabled}
                                        />
                                        <SettingRow
                                            label="Weekly Report"
                                            checked={resolveWhatsappReportWeekly}
                                            onChange={() => handleResolveWhatsappReportToggle('weekly', resolveWhatsappReportWeekly, setResolveWhatsappReportWeekly)}
                                            disabled={!resolveWhatsappEnabled}
                                        />
                                        <SettingRow
                                            label="Daily Report"
                                            checked={resolveWhatsappReportDaily}
                                            onChange={() => handleResolveWhatsappReportToggle('daily', resolveWhatsappReportDaily, setResolveWhatsappReportDaily)}
                                            disabled={!resolveWhatsappEnabled}
                                        />
                                    </Stack>
                                </div>
                            </div>
                        )}

                        <div className={`${className}__section`}>
                            <div className={`${className}__section__header`}>
                                <IoMailOutline />
                                <h2>Email Notifications</h2>
                            </div>
                            <div className={`${className}__section__content`}>
                                <p className={`${className}__section__description`}>
                                    Configure Resolve-specific email notifications. Existing non-Resolve email preferences are kept unchanged.
                                </p>
                                <SettingRow
                                    label="Enable email notifications"
                                    checked={resolveEmailEnabled}
                                    onChange={handleResolveEmailEnabledToggle}
                                />

                                <Divider sx={{ my: 2 }} />
                                <Typography variant="caption" color="var(--color-text)" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                                    Resolve Email Reports
                                </Typography>

                                <Stack spacing={0.5} sx={{ mt: 1 }}>
                                    <SettingRow
                                        label="Quarterly Report"
                                        checked={resolveEmailReportQuarterly}
                                        onChange={() => handleResolveEmailReportToggle('quarterly', resolveEmailReportQuarterly, setResolveEmailReportQuarterly)}
                                        disabled={!resolveEmailEnabled}
                                    />
                                    <SettingRow
                                        label="Monthly Report"
                                        checked={resolveEmailReportMonthly}
                                        onChange={() => handleResolveEmailReportToggle('monthly', resolveEmailReportMonthly, setResolveEmailReportMonthly)}
                                        disabled={!resolveEmailEnabled}
                                    />
                                    <SettingRow
                                        label="Weekly Report"
                                        checked={resolveEmailReportWeekly}
                                        onChange={() => handleResolveEmailReportToggle('weekly', resolveEmailReportWeekly, setResolveEmailReportWeekly)}
                                        disabled={!resolveEmailEnabled}
                                    />
                                    <SettingRow
                                        label="Daily Report"
                                        checked={resolveEmailReportDaily}
                                        onChange={() => handleResolveEmailReportToggle('daily', resolveEmailReportDaily, setResolveEmailReportDaily)}
                                        disabled={!resolveEmailEnabled}
                                    />
                                </Stack>
                            </div>
                        </div>
                    </div>
                )}

                {/* Appearance Tab */}
                {currentTab === 1 && (
                <div className={`${className}__section`}>
                    <div className={`${className}__section__header`}>
                        <IoColorPaletteOutline />
                        <h2>Appearance</h2>
                    </div>
                    <div className={`${className}__section__content`}>
                        <p className={`${className}__section__description`}>
                            Choose how KaizIQ looks to you. Select a theme or sync with your system.
                        </p>
                        <div className={`${className}__theme-options`}>
                            <ThemeOption 
                                value="light" 
                                label="Light" 
                                icon={IoEyeOutline}
                                description="Classic light mode"
                            />
                            <ThemeOption 
                                value="dark" 
                                label="Dark" 
                                icon={IoColorPaletteOutline}
                                description="Easy on the eyes"
                            />
                            <ThemeOption 
                                value="system" 
                                label="System" 
                                icon={IoSettingsOutline}
                                description="Sync with device"
                            />
                        </div>
                    </div>
                </div>
                )}

                {/* Notifications Tab */}
                {currentTab === 2 && (
                <div>
                {/* WhatsApp Section */}
                {APC_ENABLE_INTEGRATIONS_WHATSAPP && (
                    <div className={`${className}__section`}>
                        <div className={`${className}__section__header`}>
                            <IoLogoWhatsapp />
                            <h2>WhatsApp Notifications</h2>
                            <div className={`${className}__section__header__status`}>
                                {whatsappEnabled ? (
                                    <span className={`${className}__status ${className}__status--active`}>
                                        <IoCheckmarkCircle /> Enabled
                                    </span>
                                ) : (
                                    <span className={`${className}__status ${className}__status--inactive`}>
                                        <IoAlertCircle /> Disabled
                                    </span>
                                )}
                            </div>
                        </div>
                        <div className={`${className}__section__content`}>
                            <SettingRow
                                label={<span style={{ color: "var(--color-text)" }}> "Enable WhatsApp notifications" </span>}
                                checked={whatsappEnabled}
                                onChange={handleWhatsappEnabledToggle}
                                tooltip="Receive real-time updates via WhatsApp"
                            />

                            {whatsappEnabled && (
                                <>
                                    <Divider sx={{ my: 2 }} />

                                    <Accordion disableGutters elevation={0} className={`${className}__accordion`}>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                            <Stack direction="row" alignItems="center" gap={1.5}>
                                                <IoTimeOutline style={{ fontSize: 20 }} />
                                                <Typography variant="body1" fontWeight={600}>
                                                    Daily Summaries
                                                </Typography>
                                            </Stack>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Stack spacing={0.5}>
                                                <SettingRow
                                                    label={<span style={{ color: "var(--color-text)" }}> "Morning dashboard" </span>}
                                                    checked={whatsappMorningDashboard}
                                                    onChange={handleWhatsappMorningDashboardSwitch}
                                                    tooltip="Receive a summary at 9:30 AM"
                                                />
                                                {whatsappMorningDashboard && (
                                                    <FormControl size="small" sx={{ ml: 4, mt: 1 }}>
                                                        <RadioGroup row value={whatsappDashboardFreq}>
                                                            <FormControlLabel value="daily" control={<Radio size="small" />} label="Daily" />
                                                            <FormControlLabel value="monday" control={<Radio size="small" />} label="Weekly" />
                                                            <FormControlLabel value="month" control={<Radio size="small" />} label="Monthly" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                )}
                                                <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Upcoming tasks today" </span>} checked={whatsappUpcomingToday} onChange={handleWhatsappUpcomingToggle} />
                                                <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Overdue reminders" </span>} checked={whatsappOverdueDaily} onChange={handleWhatsappOverdueToggle} />
                                                <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Tomorrow's tasks" </span>} checked={whatsappUpcomingTomorrow} onChange={handleWhatsappUpcomingTomorrowToggle} />
                                            </Stack>
                                        </AccordionDetails>
                                    </Accordion>

                                    <Accordion disableGutters elevation={0} className={`${className}__accordion`}>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                            <Stack direction="row" alignItems="center" gap={1.5}>
                                                <IoNotificationsOutline style={{ fontSize: 20 }} />
                                                <Typography variant="body1" fontWeight={600}>
                                                    Item Updates
                                                </Typography>
                                            </Stack>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Stack spacing={2}>
                                                <div className={`${className}__subsection`}>
                                                    <Typography variant="caption" color="var(--color-text)" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                                                        As Assignee
                                                    </Typography>
                                                    <Stack spacing={0.5} sx={{ mt: 1 }}>
                                                        <SettingRow label={<span style={{ color: "var(--color-text)" }}> "New assignments" </span>} checked={whatsappAssigneeAssigned} onChange={handleWhatsappAssigneeAssignedToggle} />
                                                        <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Status changes" </span>} checked={whatsappAssigneeStatus} onChange={handleWhatsappAssigneeStatusToggle} />
                                                        <SettingRow label={<span style={{ color: "var(--color-text)" }}> "New comments" </span>} checked={whatsappAssigneeComment} onChange={handleWhatsappAssigneeCommentToggle} />
                                                        <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Upcoming (2 hours)" </span>} checked={whatsappAssigneeUp2h} onChange={handleWhatsappAssigneeUp2hToggle} />
                                                        <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Upcoming soon (15 min)" </span>} checked={whatsappAssigneeUp15m} onChange={handleWhatsappAssigneeUp15mToggle} />
                                                        <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Overdue now" </span>} checked={whatsappAssigneeOd15m} onChange={handleWhatsappAssigneeOd15mToggle} />
                                                        <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Weekly overdue summary" </span>} checked={whatsappAssigneeOdWeekly} onChange={handleWhatsappAssigneeOdWeeklyToggle} />
                                                    </Stack>
                                                </div>
                                                
                                                <Divider />
                                                
                                                <div className={`${className}__subsection`}>
                                                    <Typography variant="caption" color="var(--color-text)" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                                                        As Reporter
                                                    </Typography>
                                                    <Stack spacing={0.5} sx={{ mt: 1 }}>
                                                        <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Status changes" </span>} checked={whatsappReporterStatus} onChange={handleWhatsappReporterStatusToggle} />
                                                        <SettingRow label={<span style={{ color: "var(--color-text)" }}> "New comments" </span>} checked={whatsappReporterComment} onChange={handleWhatsappReporterCommentToggle} />
                                                        <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Overdue now" </span>} checked={whatsappReporterOd15m} onChange={handleWhatsappReporterOd15mToggle} />
                                                        <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Weekly overdue summary" </span>} checked={whatsappReporterOdWeekly} onChange={handleWhatsappReporterOdWeeklyToggle} />
                                                    </Stack>
                                                </div>
                                                
                                                <Divider />
                                                
                                                <div className={`${className}__subsection`}>
                                                    <Typography variant="caption" color="var(--color-text)" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                                                        As Watcher
                                                    </Typography>
                                                    <Stack spacing={0.5} sx={{ mt: 1 }}>
                                                        <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Status changes" </span>} checked={whatsappWatcherStatus} onChange={handleWhatsappWatcherStatusToggle} />
                                                        <SettingRow label={<span style={{ color: "var(--color-text)" }}> "New comments" </span>} checked={whatsappWatcherComment} onChange={handleWhatsappWatcherCommentToggle} />
                                                        <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Overdue now" </span>} checked={whatsappWatcherOd15m} onChange={handleWhatsappWatcherOd15mToggle} />
                                                        <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Weekly overdue summary" </span>} checked={whatsappWatcherOdWeekly} onChange={handleWhatsappWatcherOdWeeklyToggle} />
                                                    </Stack>
                                                </div>
                                            </Stack>
                                        </AccordionDetails>
                                    </Accordion>

                                    <Divider sx={{ my: 2 }} />
                                    <SettingRow
                                        label={<span style={{ color: "var(--color-text)" }}> "Product updates & announcements" </span>}
                                        checked={whatsappKaiziqUpdates}
                                        onChange={() => {}}
                                        tooltip="News about new features and maintenance"
                                    />
                                </>
                            )}
                        </div>
                    </div>
                )}

                {/* Email Section */}
                <div className={`${className}__section`}>
                    <div className={`${className}__section__header`}>
                        <IoMailOutline />
                        <h2>Email Notifications</h2>
                        <div className={`${className}__section__header__status`}>
                            {emailEnabled ? (
                                <span className={`${className}__status ${className}__status--active`}>
                                    <IoCheckmarkCircle /> Enabled
                                </span>
                            ) : (
                                <span className={`${className}__status ${className}__status--inactive`}>
                                    <IoAlertCircle /> Disabled
                                </span>
                            )}
                        </div>
                    </div>

                    <div className={`${className}__section__content`}>
                        <SettingRow
                            label={<span style={{ color: "var(--color-text)" }}> "Enable email notifications" </span>}
                            checked={emailEnabled}
                            onChange={handleEmailEnabledToggle}
                            tooltip="Receive updates via email"
                        />

                        {emailEnabled && (
                            <>
                                <Divider sx={{ my: 2 }} />

                                <Accordion disableGutters elevation={0} className={`${className}__accordion`}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                        <Stack direction="row" alignItems="center" gap={1.5}>
                                            <IoNotificationsOutline style={{ fontSize: 20 }} />
                                            <Typography variant="body1" fontWeight={600}>
                                                Item Updates
                                            </Typography>
                                        </Stack>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Stack spacing={2}>
                                            <div className={`${className}__subsection`}>
                                                <Typography variant="caption" color="var(--color-text)" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                                                    As Assignee
                                                </Typography>
                                                <Stack spacing={0.5} sx={{ mt: 1 }}>
                                                    <SettingRow label={<span style={{ color: "var(--color-text)" }}> "New assignments" </span>} checked={emailAssigneeAssigned} onChange={handleEmailAssigneeAssignedToggle} />
                                                    <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Status changes" </span>} checked={emailAssigneeStatus} onChange={handleEmailAssigneeStatusToggle} />
                                                    <SettingRow label={<span style={{ color: "var(--color-text)" }}> "New updates" </span>} checked={emailAssigneeNewUpdates} onChange={handleEmailAssigneeNewUpdatesToggle} />
                                                    <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Upcoming (2 hours)" </span>} checked={emailAssigneeUp2h} onChange={handleEmailAssigneeUp2hToggle} />
                                                    <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Upcoming soon (15 min)" </span>} checked={emailAssigneeUp15m} onChange={handleEmailAssigneeUp15mToggle} />
                                                    <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Overdue now" </span>} checked={emailAssigneeOd15m} onChange={handleEmailAssigneeOd15mToggle} />
                                                    <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Weekly overdue summary" </span>} checked={emailAssigneeOdWeekly} onChange={handleEmailAssigneeOdWeeklyToggle} />
                                                </Stack>
                                            </div>
                                            
                                            <Divider />
                                            
                                            <div className={`${className}__subsection`}>
                                                <Typography variant="caption" color="var(--color-text)" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                                                    As Reporter
                                                </Typography>
                                                <Stack spacing={0.5} sx={{ mt: 1 }}>
                                                    <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Item created" </span>} checked={emailReporterCreate} onChange={handleEmailReporterCreateToggle} />
                                                    <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Status changes" </span>} checked={emailReporterStatus} onChange={handleEmailReporterStatusToggle} />
                                                    <SettingRow label={<span style={{ color: "var(--color-text)" }}> "New updates" </span>} checked={emailReporterNewUpdates} onChange={handleEmailReporterNewUpdatesToggle} />
                                                    <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Overdue now" </span>} checked={emailReporterOd15m} onChange={handleEmailReporterOd15mToggle} />
                                                    <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Weekly overdue summary" </span>} checked={emailReporterOdWeekly} onChange={handleEmailReporterOdWeeklyToggle} />
                                                </Stack>
                                            </div>
                                            
                                            <Divider />
                                            
                                            <div className={`${className}__subsection`}>
                                                <Typography variant="caption" color="var(--color-text)" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                                                    As Watcher
                                                </Typography>
                                                <Stack spacing={0.5} sx={{ mt: 1 }}>
                                                    <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Item created" </span>} checked={emailWatcherCreate} onChange={handleEmailWatcherCreateToggle} />
                                                    <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Status changes" </span>} checked={emailWatcherStatus} onChange={handleEmailWatcherStatusToggle} />
                                                    <SettingRow label={<span style={{ color: "var(--color-text)" }}> "New updates" </span>} checked={emailWatcherNewUpdates} onChange={handleEmailWatcherNewUpdatesToggle} />
                                                    <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Overdue now" </span>} checked={emailWatcherOd15m} onChange={handleEmailWatcherOd15minToggle} />
                                                    <SettingRow label={<span style={{ color: "var(--color-text)" }}> "Weekly overdue summary" </span>} checked={emailWatcherOdWeekly} onChange={handleEmailWatcherOdWeeklyToggle} />
                                                </Stack>
                                            </div>
                                        </Stack>
                                    </AccordionDetails>
                                </Accordion>
                                <Divider sx={{ my: 2 }} />
                                <SettingRow
                                    label={<span style={{ color: "var(--color-text)" }}> "Product updates, Newsletters & announcements" </span>}
                                    checked={emailKaiziqUpdates}
                                    onChange={handleEmailKaiziqUpdatesToggle}
                                    tooltip="News about new features and maintenance"
                                />
                            </>
                        )}
                    </div>
                </div>
                </div>
                )}
            </div>
        </div>
    );
}